import { render, staticRenderFns } from "./user-password-change-settings.vue?vue&type=template&id=025d3495&scoped=true"
import script from "./user-password-change-settings.vue?vue&type=script&lang=js"
export * from "./user-password-change-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025d3495",
  null
  
)

export default component.exports